import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'paymentForm.details.heading',
		defaultMessage: 'Payment details',
		description: 'Heading for payment form',
	},
	modalCta: {
		id: 'paymentForm.details.cta',
		defaultMessage: 'Why now?',
		description: 'Text for payment modal cta',
	},
	buttonCta: {
		id: 'paymentForm.purchaseForm.cta2',
		defaultMessage: 'Start Your Trial',
		description: 'Cta for the submit payment form button',
	},
	modalTitle: {
		id: 'paymentForm.details.modalTitle',
		defaultMessage: 'Payment details',
		description: 'Title for payment modal CTA',
	},
});
